/**
 * The Contacts sidebar's Add contact: asks the open Contacts screen for its Add contact sheet (Google Contacts' Create
 * contact). A request made before the screen mounts (the sidebar opened Contacts first) waits for it.
 */
let pending = false;
const listeners = new Set<() => void>();

export function requestNewContact(): void {
  if (listeners.size === 0) pending = true;
  for (const l of Array.from(listeners)) l();
}

export function onNewContactRequest(listener: () => void): () => void {
  listeners.add(listener);
  if (pending) {
    pending = false;
    listener();
  }
  return () => {
    listeners.delete(listener);
  };
}
